import { render, staticRenderFns } from "./create-task-official.vue?vue&type=template&id=cdc49a10&scoped=true"
import script from "./create-task-official.vue?vue&type=script&lang=js"
export * from "./create-task-official.vue?vue&type=script&lang=js"
import style0 from "./create-task-official.vue?vue&type=style&index=0&id=cdc49a10&prod&lang=scss&scoped=true"
import style1 from "./create-task-official.vue?vue&type=style&index=1&id=cdc49a10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc49a10",
  null
  
)

export default component.exports